import { CircularProgress, Grid } from '@material-ui/core';
import { DefaultButton } from 'design-system';
import makeFormStyles from '../../styles/makeFormStyles';

type Props = {
  disabled: boolean;
  loading: boolean;
};

const ButtonSection = ({ disabled, loading }: Props): JSX.Element => {
  const classes = makeFormStyles();
  return (
    <Grid item container xs={12} justifyContent="center">
      <div className={classes.buttonContainer}>
        <DefaultButton
          fullWidth
          type="submit"
          disabled={disabled || loading}
          id="sales-web-button-next"
          data-testid="button"
        >
          {!loading && 'Siguiente'}
          {loading && (
            <CircularProgress size={20} data-testid="button-loading" />
          )}
        </DefaultButton>
      </div>
    </Grid>
  );
};

export default ButtonSection;
